function Booking() {

  return (
    <section className="booking">

      <h1>
        Book Test Drive
      </h1>

      <form className="booking-form">

        <input
          type="text"
          placeholder="Full Name"
        />

        <input
          type="email"
          placeholder="Email"
        />

        <input
          type="date"
        />

        <select>

          <option>
            Select Car
          </option>

          <option>
            Lamborghini
          </option>

          <option>
            Ferrari
          </option>

        </select>

        <button>
          Confirm Booking
        </button>

      </form>

    </section>
  );
}

export default Booking;